import { useContext } from "react";
import AuthorizationContext, {
  AuthorizationContextValueWithSetter,
} from "../context/authorizationContext";

/**
 * Custom hook to access AuthorizationContext
 */
const useAuthorization = (): AuthorizationContextValueWithSetter => {
  return useContext(AuthorizationContext);
};

export default useAuthorization;
